import type { ElementType, ReactNode } from 'react';

export interface AccessibleHiddenTextProps {
  children: ReactNode;
  as?: ElementType;
}

export function AccessibleHiddenText({
  children,
  as: Component = 'div',
}: AccessibleHiddenTextProps) {
  return <Component className="sr-only">{children}</Component>;
}
